<template>
  <div class="container">
    <div class="detail-content">
      <div class="people">
        <div class="people-label">患者姓名：</div>
        <div class="people-text">{{ billDetail.name }}</div>
      </div>
      <div class="pay-num">
        <div class="pay-num-label">检测项目:</div>
        <div class="pay-num-text">核酸检测</div>
      </div>
      <div class="pay-num">
        <div class="pay-num-label">挂号费：</div>
        <div class="pay-num-texta">￥{{ billDetail.money }}</div>
      </div>
      <div class="dl-title">就诊码</div>
      <div class="dl">
        <svg id="barcode"></svg>
      </div>
    </div>
    <div class="detail-footer">
      <div class="detail-footer-left">
        合计 <span class="much"> {{ billDetail.money }} 元</span>
      </div>
      <div class="detail-footer-right">
        <van-button round type="info" size="small" :loading="refundLoading" :loading-type="'spinner'"
          loading-text="退款中..." @click="toRefund" v-if="billDetail.refundFlag">退款</van-button>
      </div>
    </div>

  </div>
</template>

<script>
import { Dialog, Toast } from 'vant'
import { refund } from '@/api/api'
import jsbarcode from 'jsbarcode'
export default {
  data () {
    return {
      billDetail: {},
      refundLoading: false
    }
  },
  created () { },
  mounted () {
    this.billDetail = this.$route.query
    console.log(this.billDetail)
    jsbarcode('#barcode', this.billDetail.mrcode, {
      displayValue: true, // 是否在条形码下方显示文字
    })
  },
  methods: {
    toRefund () {
      Dialog.confirm({
        title: '取消挂号',
        message: '确认退号后不可撤销，是否确定退号',
      })
        .then(() => {
          // on confirm
          this.refundLoading = true;
          refund(this.billDetail.tradNo).then((res) => {
            this.refundLoading = false;
            if (res.code == 200) {
              Dialog.alert({
                message: '退号成功,钱款会在24小时内退回原账户',
              }).then(() => {
                // on close
                window.location.replace(
                  window.location.protocol +
                  '//' +
                  window.location.host +
                  '/#/acidList'
                )
              })
            } else {
              Toast(res.msg)
            }
          }).catch(err => {
            this.refundLoading = false;
          })
        })
        .catch(() => {
          // on cancel
        })
    },
  }
}
</script>

<style lang="scss" scoped>
.dl-title {
  width: 100%;
  padding: 10px 0;
  display: flex;
  justify-content: center;
  font-size: 16px;
  background: #fff;
}

.dl {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 0 0 10% 0;
  background: #fff;
}

.container {
  width: 100vw;
  height: 100vh;
  background: rgb(242, 248, 253);
}

.detail-content {
  width: 100vw;
  height: calc(100vh - 55px);
}

.detail-footer {
  width: 100vw;
  height: 55px;
  background: #fff;
  font-size: 15px;
  padding: 0 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  &-left {
    display: flex;
    align-items: center;

    .much {
      color: rgb(237, 125, 84);
      padding-left: 5px;
    }
  }

  &-right {
    display: flex;
    align-items: center;
  }
}

.people {
  width: 100%;
  display: flex;
  align-items: center;
  height: 40px;
  background: #fff;
  padding: 0 15px;
  border-bottom: 1px solid rgb(234, 234, 234);

  &-label {
    width: 80px;
    color: #666;
    display: flex;
    align-items: center;
    font-size: 13px;
  }

  &-text {
    width: calc(100% - 80px);
    font-size: 15px;
  }
}

.pay-num {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 38px;
  background: #fff;
  padding: 0 15px;
  border-bottom: 1px solid rgb(234, 234, 234);
  border-top: 1px solid rgb(234, 234, 234);

  &-label {
    color: #666;
    display: flex;
    align-items: center;
    font-size: 12px;
  }

  &-texta {
    font-size: 12px;
    color: rgb(237, 125, 84);
  }

  &-text {
    font-size: 12px;
  }
}

@font-face {
  font-family: 'iconfont1';
  src: url('data:font/truetype;charset=utf-8;base64,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') format('truetype');
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

.iconfont1 {
  font-family: 'iconfont1' !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.icon-user-wait:before {
  content: '\e6b2';
}
</style>
